<button
  class="button"
  [attr.id]="buttonId"
  [attr.accesskey]="accessKey"
  [attr.title]="title"
  [attr.aria-label]="label"
  [disabled]="disabled"
  (click)="performAction($event)"
  [ngClass]="{ '-active': isActive }"
  data-test-selector="wp-filter-button"
>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" class="button--icon">
    <path d="M2 4.5h12M2 8h12M2 11.5h12" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
    <circle cx="10" cy="4.5" r="1.6" fill="currentColor"/>
    <circle cx="5" cy="8" r="1.6" fill="currentColor"/>
    <circle cx="8.5" cy="11.5" r="1.6" fill="currentColor"/>
  </svg>
  <span class="button--text">
    {{ buttonText }}
    <span class="badge" *ngIf="initialized" [textContent]="filterCount"></span>
  </span>
</button>
